/* eslint-disable jsx-a11y/anchor-is-valid */
import { useIntl } from 'react-intl'

type Props = {
  className: string
}

const EngageWidgetTicket = ({ className }: Props) => {
  const intl = useIntl()

  return (
    <div className={`card card-flush text-light ${className}`}>
      <div className='card-body'>
        <h2 className='fw-bold mb-4 text-light'>
          {intl.formatMessage({ id: 'URL_TYPES.HEADING', defaultMessage: 'URL Registration Types' })}
        </h2>
        <p>
          <strong className='fs-3'>
            {intl.formatMessage({ id: 'URL_TYPES.STATIC_LABEL', defaultMessage: 'Static URL:' })}
          </strong>{' '}
          {intl.formatMessage({ id: 'URL_TYPES.STATIC_DESC', defaultMessage: "Register the full URL, including redirects. If anything changes after whitelisting, the SMS will be blocked. Best for URLs that won't change." })}
        </p>
        <p>
          <strong className='fs-3'>
            {intl.formatMessage({ id: 'URL_TYPES.TRUSTED_LABEL', defaultMessage: 'Trusted URL:' })}
          </strong>{' '}
          {intl.formatMessage({ id: 'URL_TYPES.TRUSTED_DESC', defaultMessage: 'Register just the domain. You can change paths or redirects later — the system will only check the domain at runtime.' })}
        </p>
        <div className='alert bg-white bg-opacity-20 mt-4'>
          {intl.formatMessage({ id: 'URL_TYPES.WARNING', defaultMessage: '⚠️ Make sure to pick the right type! Choosing incorrectly may cause your SMS to fail delivery.' })}
        </div>
      </div>
    </div>
  )
}

export { EngageWidgetTicket }
